import Table from "../../../../Components/Table/Table";

export default function HistoryList({ rows }) {
  return (
    <div className="hidden min-h-0 flex-1 mb:flex-initial mb:flex mb:flex-col">
      <Table
        isEnglish={[8]}
        isLTR={true}
        haveScroll={true}
        maxHeight="260px"
        columns={[
          { key: "symbol", label: "نماد" },
          { key: "side", label: "ساید" },
          { key: "type", label: "نوع" },
          { key: "openDate", label: "زمان ورود" },
          { key: "entryPrice", label: "قیمت ورود" },
          { key: "closeDate", label: "زمان خروج" },
          { key: "exitPrice", label: "قیمت خروج" },
          { key: "totalCost", label: "حجم" },
          {
            key: "pnl",
            label: "سود",
            render: (value, row) => {
              if (row.numberPnl && row.numberPnl > 0) {
                return (
                  <div className="py-1 px-2 rounded-md bg-zi-green-dark/10 ring-1 ring-inset ring-zi-green-dark text-zi-green-dark">
                    <p style={{ direction: "ltr" }}>{value}</p>
                  </div>
                );
              }

              if (row.numberPnl && row.numberPnl < 0) {
                return (
                  <div className="py-1 px-2 rounded-md bg-zi-red-dark/10 ring-1 ring-inset ring-zi-red-dark text-zi-red-dark">
                    <p style={{ direction: "ltr" }}>{value}</p>
                  </div>
                );
              }

              return (
                <div className="py-1 px-2 rounded-md">
                  <p style={{ direction: "ltr" }}>{value}</p>
                </div>
              );
            },
          },
        ]}
        data={rows}
      />
    </div>
  );
}
